import { useContext } from "react";
import { validateUserPermissions } from "../components/util/Can/validateUserPermissions";
import { AuthContext } from "../contexts/AuthContext";

export const useCan = ({ permissions = [""], some = false }) => {
    const { user } = useContext(AuthContext);

    const userHasValidPermissions = validateUserPermissions({
        user,
        permissions,
        some,
    });

    return userHasValidPermissions;
};
